import { SequenceFlow } from './SequenceFlow';
import { MessageFlow } from './MessageFlow';
import { Association } from './Association';
import { DataInputAssociation, DataOutputAssociation } from './DataAssociation';

export const EDGES = [SequenceFlow, MessageFlow, Association, DataInputAssociation, DataOutputAssociation];

export function registerEdges(lf) {
  EDGES.forEach(({ type, view, model }) => {
    lf.register({ type, view, model });
  });
}
